// extracted by mini-css-extract-plugin
export default {"contentDiv":"styles_contentDiv__dRyO9","time":"styles_time__jfu8G","deleteButton":"styles_deleteButton__rsLoS","editButton":"styles_editButton__sW7wh"};